module.exports = __webpack_public_path__ + "static/matiaswork7-fc8851b4f1d3539b4d23ad7652a38b86.jpg";